import { render } from "./VerticalInsuranceStepNavigator.vue?vue&type=template&id=0a9af71b&scoped=true&ts=true"
import script from "./VerticalInsuranceStepNavigator.vue?vue&type=script&lang=ts"
export * from "./VerticalInsuranceStepNavigator.vue?vue&type=script&lang=ts"

import "./VerticalInsuranceStepNavigator.vue?vue&type=style&index=0&id=0a9af71b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a9af71b"]])

export default __exports__